import styles from './Login.module.css';

interface LoginProps {
  onLogin: () => void;
}

export default function Login({ onLogin }: LoginProps) {
  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <div className={styles.authLogo}>
          <span className={styles.logoIcon}>V</span>
          <h1>Vocabulizer</h1>
        </div>

        <p className={styles.authTagline}>
          AI-powered vocabulary extraction for educators. Upload any text and get grade-appropriate
          word lists in seconds.
        </p>

        <div className={styles.authFeatures}>
          <div className="feature">
            <span className="feature-icon">📄</span>
            <span>Upload PDF, EPUB, DOCX, TXT, or paste a URL</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🔬</span>
            <span>Latin &amp; Greek root analysis</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🎯</span>
            <span>Grade-level calibration (K–2 through College)</span>
          </div>
          <div className="feature">
            <span className="feature-icon">📝</span>
            <span>Generate quizzes, flashcards, &amp; worksheets</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🔑</span>
            <span>Your Claude API key — stored securely, used privately</span>
          </div>
        </div>

        <button className={`btn btn-google ${styles.btnGoogle}`} onClick={onLogin}>
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path
              fill="#4285F4"
              d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"
            />
            <path
              fill="#34A853"
              d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"
            />
            <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18z" />
            <path
              fill="#EA4335"
              d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"
            />
          </svg>
          Sign in with Google
        </button>

        <p className={styles.authNote}>
          Your Google account is used only for authentication. No Google data is stored beyond your
          name and email.
        </p>
      </div>
    </div>
  );
}
